module.exports = __webpack_public_path__ + "static/media/greyscale.14f62fbd.svg";